// UPLOADED means the bytes are in S3 but no record has come back yet; the classification overlay in
// useEasyModeDocuments moves the row on to CLASSIFYING and then CLASSIFIED.
//
// BAD_RECORD is the pipeline's verdict that the file cannot be read at all - an encrypted or image-only
// PDF Textract returned nothing for. It is distinct from FAILED, which is an upload that never arrived:
// the bytes are in S3, so there is nothing to retry and removing it is the only way forward.
export const EASY_MODE_UPLOAD_STATUS = {
  PENDING: 'PENDING',
  UPLOADING: 'UPLOADING',
  UPLOADED: 'UPLOADED',
  CLASSIFYING: 'CLASSIFYING',
  CLASSIFIED: 'CLASSIFIED',
  FAILED: 'FAILED',
  BAD_RECORD: 'BAD_RECORD'
};

// The header counter reads fully classified, which is what the user is actually waiting for
export const EASY_MODE_COMPLETED_STATUSES = [EASY_MODE_UPLOAD_STATUS.CLASSIFIED];

// The trash-can only appears once a document has finished, never mid-upload or mid-classification
export const EASY_MODE_REMOVABLE_STATUSES = [
  EASY_MODE_UPLOAD_STATUS.CLASSIFIED,
  EASY_MODE_UPLOAD_STATUS.FAILED,
  EASY_MODE_UPLOAD_STATUS.BAD_RECORD
];

export const EASY_MODE_ACCEPTED_EXTENSIONS = [
  '.pdf',
  '.doc',
  '.docx',
  '.jpg',
  '.jpeg',
  '.png',
  '.heic',
  '.heif'
];

export const EASY_MODE_MAX_FILE_COUNT = 200;

// matches the ceiling the rest of the app enforces through validateFilesForUpload
export const EASY_MODE_MAX_FILE_SIZE_BYTES = 500 * 1024 * 1024;

// the checklist shown inside the dropzone so the lawyer knows what to drop
export const EASY_MODE_DROPZONE_DOCUMENT_TYPES = [
  'Medical records',
  'Bills',
  'Police reports',
  'Insurance docs',
  'Photos (accident, property damage, or injury, etc.)',
  'Witness statements',
  'Expert safety reports'
];
